import { render, staticRenderFns } from "./PictureCardListUpload1.vue?vue&type=template&id=12f3104c&scoped=true"
import script from "./PictureCardListUpload1.vue?vue&type=script&lang=js"
export * from "./PictureCardListUpload1.vue?vue&type=script&lang=js"
import style0 from "./PictureCardListUpload1.vue?vue&type=style&index=0&id=12f3104c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3104c",
  null
  
)

export default component.exports